import "./App.css";
// import '@deere/ux.uxframe-core/dist/css/uxframe.min.css';
import MainEDIContainer from "./components/edi-testing/edi-testing";
import { LoginCallback, SecureRoute, Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Route, Switch, useHistory, Redirect } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { useFuelTheme } from "@deere/fuel-react/useFuelTheme";
import CssBaseline from "@mui/material/CssBaseline";
import { UserDetailsProvider, ChatbotDetailsProvider } from "./context";

const oktaAuth = new OktaAuth({
  // added the || '' at the end of this line to remove the error
  issuer: process.env.REACT_APP_ISSUER || "",
  clientId: process.env.REACT_APP_CLIENT_ID,
  redirectUri: window.location.origin + "/login/callback",
  pkce: true,
  scopes: [
    "openid",
    "profile",
    "email",
    "EDIAdGroups",
    "EDISupplierSelfServiceAdminGroup",
    "GTLSUPPORTGroup",
    process.env.REACT_APP_OKTA_SCOPE!,
  ],
});
const App: React.FC = () => {
  const theme = useFuelTheme();
  const history = useHistory();
  const restoreOriginalUri = async (_oktaAuth: any, originalUri: any) => {
    history.replace(toRelativeUrl(originalUri, window.location.origin));
  };
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />{" "}
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        {" "}
        <UserDetailsProvider>
          <ChatbotDetailsProvider>
            {" "}
          <Switch>
            {" "}
            <SecureRoute
              path="/ediSelfServicePortal"
              component={MainEDIContainer}
            />{" "}
            <Route path="/login/callback" component={LoginCallback} />{" "}
            <Route path="/">
              {" "}
              <Redirect to="/ediSelfServicePortal" />{" "}
            </Route>{" "}
          </Switch>{" "}
          </ChatbotDetailsProvider>
          
        </UserDetailsProvider>{" "}
      </Security>{" "}
    </ThemeProvider>
  );
};

export default App;
